import React from 'react';

import { defaultSignatureFieldHeightPx, defaultSignatureFieldWidthPx, Select } from '@aline/common';
import { useSelectCurrentUser } from 'src/gql';
import { useRefreshableFilestackImg } from 'src/helpers/integrations/filestack-download';
import type { ReactSetStateAction } from 'src/types';

interface TypedSignaturePreviewProps {
  setTypedSignaturePreviewCanvas: ReactSetStateAction<HTMLCanvasElement | null>;
  typedSignature: string;
}

export function TypedSignaturePreview({
  setTypedSignaturePreviewCanvas,
  typedSignature,
}: TypedSignaturePreviewProps): JSX.Element {
  const currentUser = useSelectCurrentUser();
  const { onError, src } = useRefreshableFilestackImg(currentUser?.settings.signatureImg);

  if (!typedSignature && src)
    return (
      <img
        alt="signature"
        data-cy={Select.dialog.signatureDialog.typedSignatureImg}
        height={defaultSignatureFieldHeightPx}
        src={src}
        width={defaultSignatureFieldWidthPx}
        onError={onError}
      />
    );

  return (
    <canvas
      ref={setTypedSignaturePreviewCanvas}
      data-cy={Select.dialog.signatureDialog.typedSignatureCanvas}
      height={defaultSignatureFieldHeightPx}
      width={defaultSignatureFieldWidthPx}
    />
  );
}
